import React, { useState, useEffect, useRef } from 'react';
import SelectableAlertCard from './SelectableAlertCard';
import { Skeleton, Box } from '@mui/material';

/**
 * LazyAlertCard - Virtual rendering wrapper for SelectableAlertCard
 * Only renders the actual card when it comes into viewport, shows skeleton otherwise
 * Uses Intersection Observer for optimal performance
 */
const LazyAlertCard = (props) => {
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef(null);
  
  
  useEffect(() => {
    if (isVisible) return; // Already visible, don't observe
    
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Stop observing once visible
        }
      },
      { 
        rootMargin: '100px', // Start loading 100px before visible
        threshold: 0 // Trigger as soon as any part becomes visible
      }
    );
    
    // Use a timeout to ensure DOM is ready
    const timeoutId = setTimeout(() => {
      if (containerRef.current) {
        observer.observe(containerRef.current);
      }
    }, 10);
    
    return () => {
      clearTimeout(timeoutId);
      observer.disconnect();
    };
  }, [isVisible]);
  
  // Fixed height container to prevent layout shift - match card flex behavior
  return (
    <Box ref={containerRef} sx={{ 
      minHeight: '180px', 
      width: '280px',     // Fixed width for consistency
      flexShrink: 0       // Prevent shrinking
    }}>
      {isVisible ? (
        <SelectableAlertCard {...props} />
      ) : (
        <Skeleton 
          variant="rectangular" 
          height={180} 
          sx={{ 
            borderRadius: '12px',
            backgroundColor: 'rgba(0, 0, 0, 0.04)'
          }} 
        />
      )}
    </Box>
  );
};

export default LazyAlertCard;